"use client";

import { Theme } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useLocale, useTranslations } from "next-intl";

interface D3ClientPage {
  theme: Theme;
  locale: string;
  t: ReturnType<typeof useTranslations>; // ✅ 정확한 타입 유추
}

export const useD3ClientPage = (): D3ClientPage => {
  const theme = useTheme();
  const locale = useLocale();
  const t = useTranslations(); // ✅ 올바른 훅 사용

  return {
    theme,
    locale,
    t,
  };
};
